import { Component, inject, input, output, signal } from '@angular/core';
import { TranslocoPipe, TranslocoService } from '@jsverse/transloco';
import { ChevronDownIconComponent, GlobeIconComponent, CheckIconComponent } from '@kuiper/icons';
import { ClickOutSideDirective } from '../../../../ui-components/directives/clickOutSide.directive';
import { CookieService } from '../../services/cookie/cookie.service';
import { AppStorage } from '../../enums/app-storage';

@Component({
  selector: 'lib-lang-switcher',
  imports: [TranslocoPipe, ChevronDownIconComponent, GlobeIconComponent, CheckIconComponent, ClickOutSideDirective],
  templateUrl: './lang-switcher.component.html',
  styleUrl: './lang-switcher.component.scss',
})
export class LangSwitcherComponent {
  readonly cookieService = inject(CookieService);
  readonly translocoService = inject(TranslocoService);

  isLandingPage = input<boolean>(false);
  languageSwitched = output<('en' | 'ar')>();

  isLanguageDropdownOpen = signal(false);
  currentLanguage = signal(this.translocoService.getActiveLang());

  toggleLanguageDropdown(): void {
    this.isLanguageDropdownOpen.set(!this.isLanguageDropdownOpen());
  }

  switchLanguage(lang: 'en' | 'ar'): void {
    this.cookieService.set(AppStorage.language, lang);
    this.translocoService.setActiveLang(lang);
    this.currentLanguage.set(lang);
    this.isLanguageDropdownOpen.set(false);
    this.languageSwitched.emit(lang);
    if (!this.isLandingPage()) {
      location.reload();
    }
  }
}
